import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.249 2C16.798 2 20.499 5.729 20.499 10.313C20.499 15.948 14.043 21.5 12.249 21.5C10.455 21.5 3.99902 15.948 3.99902 10.313C3.99902 5.729 7.70002 2 12.249 2ZM12.249 3.5C8.52702 3.5 5.49902 6.557 5.49902 10.313C5.49902 15.092 11.123 19.748 12.249 19.996C13.375 19.747 18.999 15.091 18.999 10.313C18.999 6.557 15.971 3.5 12.249 3.5ZM12.25 7C14.042 7 15.5 8.458 15.5 10.251C15.5 12.043 14.042 13.5 12.25 13.5C10.458 13.5 9.00002 12.043 9.00002 10.251C9.00002 8.458 10.458 7 12.25 7ZM12.25 8.5C11.285 8.5 10.5 9.285 10.5 10.251C10.5 11.216 11.285 12 12.25 12C13.215 12 14 11.216 14 10.251C14 9.285 13.215 8.5 12.25 8.5Z",
      fill: _ctx.color || 'black'
    }, null, 8, _hoisted_2)
  ]))
}
}

})